const IMG = process.env.PUBLIC_URL + "/beef-release-your-rage/img/";

export const heroBg = IMG + "hero-ripple-bg.webp";
export const beefLogo = IMG + "beef-logo.webp";
export const emmyBanner = IMG + "emmy-banner.webp";
export const emmyBannerMobile = IMG + "emmy-banner-mobile.webp";
export const netflixN = IMG + "netflix-n.svg";
export const iconMap = IMG + "icon-map.svg";
export const iconArrowDown = IMG + "icon-arrow-down.svg";
export const iconChevron = IMG + "icon-chevron.svg";
export const pinNormal = IMG + "pin-normal.svg";
export const pinHighlighted = IMG + "pin-highlighted.svg";

const cards = {
  "card-pause": IMG + "card-pause.webp",
  "card-heyday": IMG + "card-heyday.webp",
  "card-sunlife": IMG + "card-sunlife.webp",
  "card-stagger": IMG + "card-stagger.webp",
  "card-theden": IMG + "card-theden.webp",
};

export function resolveAsset(key) {
  return key ? cards[key] : undefined;
}
